<ng-container *ngIf="control">
  <mat-form-field class="{{ additionalClass() }}" [floatLabel]="control.value ? 'always' : 'auto'">
    <mat-label [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    
    <input
      matInput
      type="text"
      [autocomplete]="autocomplete()"
      [formControl]="control"
      [mask]="maskComputed()"
      [dropSpecialCharacters]="false"
      [pattern]="patternComputed()"
      [attr.disabled]="disabled"
      [readonly]="readonly()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
      (keypress)="onKeyPress($event)"
    />
  
    <mat-hint align="start" *ngIf="startHint()">
      <strong>{{ startHint() }}</strong>
    </mat-hint>
    <mat-hint align="end" *ngIf="endHint()">
      <strong>{{ endHint() }}</strong>
    </mat-hint>

    <mat-error *ngIf="showError && control?.hasError('required')" [id]="''">Required</mat-error>
    <mat-error *ngIf="control?.hasError('pattern')">{{ patternErrorMessageComputed() }}</mat-error>
    <mat-error *ngIf="control?.hasError('message')" [id]="''">{{ control.getError('message') }}</mat-error>
  </mat-form-field>
</ng-container>
